import React, { useState, useEffect } from "react";
import Button from "../../components/button/Button";
import Input from "../../components/inputs/Input";
import "./Login.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveRestaurant } from "../../features/restaurant/restaurant";
import secureLocalStorage from "react-secure-storage";
import { loginUser } from "../../services/login";
import { restaurantsAll } from "../../services/restaurants";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectRestaurant, setSelectedRestaurant] = useState("");
  const [allRestaurants, setAllRestaurants] = useState();
  const [loadingRestaurants, setLoadingRestaurants] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("View " + Login.name + " OPENED");
    getAllRestaurants();
    return () => {
      console.log("View " + Login.name + " CLOSED");
    };
  }, []);

  function getAllRestaurants() {
    setLoadingRestaurants(true);
    restaurantsAll().then(response => {
      setAllRestaurants(response.items);
      setLoadingRestaurants(false);
    })
      .catch((error) => {
        console.error("Erro ao carregar restaurantes:", error);
        setLoadingRestaurants(false);
      });
  }

  function login() {
    if (allRestaurants && allRestaurants.length > 0) {
      let selectedRestaurant = selectRestaurant
        ? allRestaurants.find(restaurant => restaurant.id === parseInt(selectRestaurant, 10))
        : allRestaurants[0];

      if (selectedRestaurant && selectedRestaurant.id) {
        loginUser({ email, password })
          .then((response) => {
            secureLocalStorage.setItem("restaurant", selectedRestaurant.id.toString());
            secureLocalStorage.setItem("user_id", response.user_id);
            secureLocalStorage.setItem("restaurant_name", selectedRestaurant.name);
            secureLocalStorage.setItem("neighborhood_id", selectedRestaurant.neighborhood_id);
            dispatch(saveRestaurant(selectedRestaurant));
            navigate("/delivery");
          })
          .catch((error) => {
            console.error("Erro no login:", error);
            toast.error("Email ou senha incorreto", { type: "error" });
          });
      } else {
        console.error("Restaurante selecionado inválido ou sem ID.");
      }
    } else {
      console.error("Nenhum restaurante carregado.");
    }
  }

  return (
    <div className="main-base">
      <ToastContainer
        position={window.screen.width > 600 ? "bottom-center" : "top-center"}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
      />
      <div className="image-base" />
      <div className="login-base">
        <div className="login-base-box">
          <div className="login-base-box-children-logo">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <image src={"/logo.jpeg"} alt="delivery image" style={{ height: 180, width: 300 }} />
            </div>
          </div>
          <div className="login-base-box-children-text">
            <p className="label-32-bold">Bem vindo</p>
            <p className="label-16-regular">Entre com seu email e senha</p>
          </div>
          <div className="login-base-box-children">
          <select
            className="selectRestaurant"
            value={selectRestaurant}
            placeholder="Selecione um restaurante"
            onChange={(e) => setSelectedRestaurant(e.target.value)}
            disabled={loadingRestaurants}
          >
            {loadingRestaurants ? (
              <option>Carregando restaurantes...</option>
            ) : (
              allRestaurants?.map((restaurant) => (
                <option
                  className="selectRestaurant"
                  key={restaurant.id}
                  value={restaurant.id}
                >
                  {restaurant.name}
                </option>
              ))
            )}
          </select>


            <Input placeholder="Email" type="text" setValue={setEmail} />
            <Input
              placeholder="Password"
              type="password"
              setValue={setPassword}
            />

            <Button text="Entrar" onClick={login} />
          </div>
        </div>
      </div>
    </div>
  );
}
